var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"min-h-full flex flex-col gap-4 -m-4 bg-white p-6"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }